import { localeSaga, sendOTPSaga, verifyOTPSaga, resendOTPSaga } from '@store/branches/auth/sagas';
import {
	fetchSelectedUserPermissionsSaga,
	fetchCreditsSaga,
	fetchUserDetailsSaga,
	fetchUserPermissionsSaga,
	updateProfilePictureSaga,
	updateCreditsSaga,
	updateUserDetailsSaga,
	updateUserPermissionsSaga
} from './branches/user/sagas';
import {
	addInspirationItemMappingSaga,
	addInspirationSaga,
	deleteInspirationItemMappingSaga,
	deleteInspirationSaga,
	fetchAllInspirationsSaga,
	fetchInspirationDetailsSaga,
	fetchInspirationProductMappingSaga,
	fetchShortlistedInspirationSaga,
	removeShortlistedInspirationSaga,
	shortlistInspirationSaga,
	updateInspirationItemSaga,
	updateItemInclusionStatusSaga
} from './branches/inspirations/sagas';
import {
	addAreaToQuotationQuotationSaga,
	changeAreaNicknameSaga,
	changeQuotationImageSaga,
	copyQuotationItemSaga,
	createLeadSaga,
	deleteQuotationVersionSaga,
	fetchFCBuilderDataSaga,
	fetchLeadAutocompleteSaga,
	fetchLeadDetailsSaga,
	fetchLeadProjectsSaga,
	fetchLeadQuotationSaga,
	fetchLeadsSaga,
	fetchQuotationToolListSaga,
	updateFCBuilderSaga,
	updateLeadBasicDetailsSaga,
	updateLeadQuotationSaga,
	updateQuotationItemSaga,
	uploadQuotationImageSaga,
	uploadQuotationPDFSaga,
	fetchLeadCreditsSaga,
	addLeadCreditsSaga,
	importQuotationSaga,
	fetchLeadSourceHistorySaga,
	fetchLeadRemarksSaga,
	putLeadRemarkSaga,
	refreshLeadQuotationCostingSaga,
	fetchCostingSyncStatusSaga
} from './branches/leads/sagas';
import {
	addUserSaga,
	fetchAllUsersSaga,
	fetchDepartmentsSaga,
	fetchDesignationsSaga,
	fetchManagerAutocompleteSaga,
	updateEmployeeDetailsSaga,
	deleteEmployeeSaga,
	fetchUserByIdSaga,
	fetchAssignedProjectsSaga
} from './branches/organization/sagas';
import {
	addCategorySubcategorySaga,
	addProductGroupSaga,
	addProductItemSaga,
	addWarrantySaga,
	addXorGroupSaga,
	bulkEditWarrantySaga,
	deleteProductGroupSaga,
	deleteCategorySaga,
	deleteProductImageSaga,
	deleteProductSaga,
	bulkEditProductsSaga,
	uploadProductImageForBulkEditSaga,
	deleteSubCategorySaga,
	deleteXorGroupSaga,
	deleteWarrantySaga,
	fetchAllCategoriesSaga,
	fetchAllProductCategoriesSaga,
	fetchAllProductItemsSaga,
	fetchAllProductsSaga,
	fetchAllProductSubCategoriesSaga,
	fetchAllProductsWarrantySaga,
	fetchAreaListDropdownSaga,
	fetchAllProductItemsSagaV2,
	fetchProductAreaItemSaga,
	fetchProductDetailsSaga,
	fetchProductItemHistorySaga,
	fetchProductTaxonomySaga,
	uploadProduct3DModelSaga,
	removeProduct3DModelSaga,
	fetchDefaultModelsSaga,
	uploadSubcategoryDefaultModelSaga,
	removeSubcategoryDefaultModelSaga,
	fetchWarrantyDetailsByCodesSaga,
	fetchInternalCategoriesSaga,
	updateCategorySubcategorySaga,
	updateCoverImageSaga,
	updateProductGroupSaga,
	updateProductImagesSaga,
	updateProductItemSaga,
	updateWarrantySaga,
	updateXorGroupSaga
} from './branches/products/sagas';

import {
	addQuotationsSaga,
	closeTicketSaga,
	fetchCustomerDetailsSaga,
	fetchFloorPlanImageSaga,
	fetchProductCategoriesSaga,
	fetchCutlistDataSaga,
	fetchOptimiserDataSaga,
	fetchQuotationByIdSaga,
	fetchQuotationsSaga,
	fetchSavedQuotationSaga,
	fetchThreeDJsonSaga,
	fetchTicketChatSaga,
	fetchTwoDJsonSaga,
	getDefaultQuotationsSaga,
	getPreDesignQuotationSaga,
	getPredictionIdSaga,
	getPredictionSaga,
	resendCustomerOTPSaga,
	sendChatMessageSaga,
	sendCustomerOTPSaga,
	updateFloorPlanSaga,
	updateQuotationSaga,
	uploadProjectDetailsSaga,
	verifyCustomerOTPSaga
} from './branches/customer/sagas';
import { createQuotationSaga, fetchPromoCodeHistorySaga, calculatePromoCodeAmountSaga, fetchPreDesignSavedStateSaga } from './branches/project/sagas';
import {
	addProjectDiscountSaga,
	editDiscountAmountSaga,
	editCashDiscountAmountSaga,
	addProjectSaga,
	approveRequestSaga,
	rejectRequestSaga,
	completeProjectActivitySaga,
	deleteActivityDocumentsSaga,
	fetchActivityDocumentsSaga,
	fetchAllApprovalSaga,
	fetchApprovalDocumentsSaga,
	fetchAssigneeAutocompleteSaga,
	fetchAssigneeDropdownSaga,
	fetchQCDropdownSaga,
	fetchCollaboratorAutocompleteSaga,
	fetchDesignerDropdownSaga,
	fetchProductionDropdownSaga,
	fetchLeadDesignerAutoCompleteSaga,
	fetchLedgerDataSaga,
	recalculateLedgerSaga,
	fetchProjectDiscountsSaga,
	fetchOrdersSaga,
	fetchProjectActivitiesSaga,
	fetchProjectDetailsSaga,
	fetchProjectFloorPlanImageSaga,
	fetchProjectsSaga,
	deleteProjectSaga,
	fetchWarrantyClaimsSaga,
	fetchWarrantyClaimByIdSaga,
	updateWarrantyClaimSaga,
	approveWarrantyClaimSaga,
	rejectWarrantyClaimSaga,
	scheduleWarrantyClaimSaga,
	updateWarrantyClaimScheduleSaga,
	submitWarrantyQuoteSaga,
	submitWarrantyFinalQuoteSaga,
	updateWarrantyChargesSaga,
	updateWarrantyClaimStatusesSaga,
	updateWarrantyClaimDiscountSaga,
	fetchWarrantyDocumentsSaga,
	scheduleSiteVisitSaga,
	updateActivityDetailsSaga,
	updateProjectDetailsSaga,
	uploadActivityDocumentSaga,
	fetchProjectAssigneesSaga,
	applyPromoCodeSaga,
	removePromoCodeSaga,
	fetchFinanceDropdownSaga,
	fetchProcurementDropdownSaga,
	fetchManufacturingDropdownSaga,
	fetchProjectManagementDropdownSaga,
	fetchProjectWarrantySaga,
	putLifetimeWarrantySaga,
	fetchOptimizedCutlistDataSaga
} from './branches/projects/sagas';
import { addHolidaySaga, deleteHolidaySaga, fetchHolidaysSaga, updateHolidaySaga } from './branches/holidays/sagas';
import {
	ApprovePaymentSaga,
	createGstInvoiceSaga,
	fetchAllPaymentsSaga,
	fetchCustomerSlipSaga,
	fetchGstInvoiceSaga,
	fetchPaymentSlipSaga,
	fetchProjectAutocompleteSaga
} from './branches/commercialPayments/sagas';
import { fetchAllTicketsSaga } from './branches/tickets/sagas';
import {
	editFCCostingSaga,
	fetchFCMaterialCostingSaga,
	editFCMaterialCostingSaga,
	addFCMaterialCostingSaga,
	editFCLumenCostingSaga,
	fetchFCCostingSaga,
	fetchFCLumenCostingSaga,
	fetchCabinetMaterialsSaga,
	fetchWallPanelMaterialsSaga,
	editCabinetMaterialsSaga,
	editWallPanelMaterialsSaga,
	fetchCounterTopMaterialsSaga,
	editCounterTopMaterialsSaga,
	fetchWallTilesSaga,
	addWallTileSaga,
	updateWallTileSaga,
	fetchLightingMaterialsSaga,
	fetchDriverMaterialsSaga,
	fetchElectricalModulesSaga,
	editElectricalModulesSaga,
	fetchElectricalMaterialsSaga,
	editElectricalMaterialsSaga,
	fetchPaintMaterialsSaga,
	editPaintMaterialsSaga,
	fetchMouldingTypesSaga,
	fetchMouldingPatternsSaga,
	editMouldingTypesSaga,
	editMouldingPatternsSaga,
	fetchSFBMaterialsSaga,
	editSFBMaterialsSaga,
	fetchCurtainMaterialsSaga,
	editCurtainMaterialsSaga,
	fetchBuilderChargeConfigsSaga,
	upsertBuilderChargeConfigSaga
} from './branches/builderCosting/sagas';
import {
	fetchCabinetStateSaga,
	updateCabinetStateSaga,
	fetchCabinetCutlistSaga,
	updateCabinetCutlistSaga,
	getCabinetCalculationSaga,
	updateCabinetMaterialsInBulkSaga,
	getCounterTopCalculationSaga,
	getCounterTopStateSaga,
	getLoftCalculationSaga,
	fetchLoftCutlistSaga,
	fetchLoftStateSaga,
	fetchWallPanelStateSaga,
	getWallPanelCalculationSaga,
	fetchWardrobeStateSaga,
	fetchWardrobeCalculationSaga,
	fetchWardrobeCutlistSaga,
	getElectricalCalculationSaga,
	getProjectElectricalStateSaga,
	updateElectricalStateSaga,
	getPaintBuilderCalculationSaga,
	getPaintBuilderStateSaga,
	fetchAllBuilderStatesSaga,
	getWallMouldingStateSaga,
	getWallMouldingCalculationSaga,
	fetchWallMouldingBuilderStateSaga,
	updatePreDesignBuilderSaga,
	fetchDrawerStateSaga,
	fetchDrawerCalculationSaga,
	fetchDrawerCutlistSaga,
	fetchLedgeStateSaga,
	fetchLedgeCalculationSaga,
	fetchLedgeCutlistSaga,
	fetchCurtainStateSaga,
	getCurtainCalculationSaga
} from './branches/builder/sagas';
import {
	fetchPromoCodeSaga,
	fetchProjectOverviewSaga,
	fetchProjectsCostsSaga,
	fetchStatusSummarySaga,
	fetchDashboardTicketsSaga,
	fetchDashboardProjectsSaga,
	fetchDashboardApprovalsSaga,
	fetchPromoCodeHistorySaga as fetchDashboardPromoCodeHistorySaga,
	createCustomPromoCodeSaga,
	fetchAnalyticsDataSaga,
	fetchFinancialDataSaga,
	fetchCRMDataSaga,
	fetchExecutiveDataSaga
} from './branches/dashboard/sagas';
import {
	fetchTeamWiseIncentivesSaga,
	fetchTeamWiseIncentivesByProjectIdSaga,
	fetchTeamWiseShareSaga
} from './branches/incentives/sagas';
import {
	createFeedbackSaga,
	fetchAllFeedbackSaga,
	getFeedbackByIdSaga,
	resolveFeedbackSaga
} from './branches/feedback/sagas';
import {
	fetchAllEmailCCConfigsSaga,
	getEmailCCConfigByNameSaga,
	upsertEmailCCConfigSaga,
	fetchEmailAutocompleteSaga
} from './branches/emailConfig/sagas';
import { uploadInputImageSaga, generateImageSaga } from './branches/aimagine/saga';
import { generateRenderSaga } from './branches/imagen/sagas';

export default [
	localeSaga,
	sendOTPSaga,
	verifyOTPSaga,
	resendOTPSaga,
	fetchUserDetailsSaga,

	fetchAllCategoriesSaga,
	addCategorySubcategorySaga,
	updateCategorySubcategorySaga,
	deleteCategorySaga,
	fetchAllProductsSaga,
	fetchAllProductCategoriesSaga,
	fetchAllProductSubCategoriesSaga,
	fetchLeadAutocompleteSaga,
	createLeadSaga,
	fetchLeadsSaga,
	fetchProjectsSaga,
	deleteProjectSaga,
	fetchCollaboratorAutocompleteSaga,
	fetchLeadDesignerAutoCompleteSaga,
	fetchQCDropdownSaga,
	fetchAssigneeAutocompleteSaga,
	deleteProductSaga,
	fetchProductDetailsSaga,
	fetchProductItemHistorySaga,
	fetchAllProductItemsSaga,
	fetchAllProductItemsSagaV2,
	addProductItemSaga,
	deleteSubCategorySaga,
	fetchProductTaxonomySaga,
	uploadProduct3DModelSaga,
	removeProduct3DModelSaga,
	fetchDefaultModelsSaga,
	uploadSubcategoryDefaultModelSaga,
	removeSubcategoryDefaultModelSaga,
	addXorGroupSaga,
	updateXorGroupSaga,
	deleteXorGroupSaga,
	addProductGroupSaga,
	updateProductGroupSaga,
	deleteProductGroupSaga,
	updateProductItemSaga,
	bulkEditProductsSaga,
	uploadProductImageForBulkEditSaga,
	updateCoverImageSaga,
	updateProductImagesSaga,
	fetchProductAreaItemSaga,
	deleteProductImageSaga,
	fetchAreaListDropdownSaga,
	fetchWarrantyDetailsByCodesSaga,
	fetchInternalCategoriesSaga,
	fetchOrdersSaga,
	fetchProjectAssigneesSaga,
	fetchProjectFloorPlanImageSaga,

	//LEAD QUOTATIONS
	updateQuotationItemSaga,
	uploadQuotationPDFSaga,
	updateLeadQuotationSaga,

	//QUOTATIONS
	fetchLeadQuotationSaga,
	fetchQuotationToolListSaga,
	deleteQuotationVersionSaga,
	addAreaToQuotationQuotationSaga,
	uploadQuotationImageSaga,
	changeQuotationImageSaga,
	copyQuotationItemSaga,
	importQuotationSaga,
	fetchTwoDJsonSaga,
	fetchThreeDJsonSaga,

	//inspiration
	fetchAllInspirationsSaga,
	fetchInspirationDetailsSaga,
	addInspirationSaga,
	fetchInspirationProductMappingSaga,
	updateItemInclusionStatusSaga,
	deleteInspirationItemMappingSaga,
	addInspirationItemMappingSaga,
	deleteInspirationSaga,
	shortlistInspirationSaga,
	fetchShortlistedInspirationSaga,
	removeShortlistedInspirationSaga,
	updateInspirationItemSaga,

	//credits
	fetchCreditsSaga,
	updateCreditsSaga,
	fetchLeadCreditsSaga,
	addLeadCreditsSaga,
	fetchLeadSourceHistorySaga,
	fetchLeadRemarksSaga,
	putLeadRemarkSaga,
	refreshLeadQuotationCostingSaga,
	fetchCostingSyncStatusSaga,

	//warranty
	fetchAllProductsWarrantySaga,
	addWarrantySaga,
	updateWarrantySaga,
	bulkEditWarrantySaga,
	deleteWarrantySaga,
	fetchAllUsersSaga,
	updateUserDetailsSaga,
	updateProfilePictureSaga,
	addUserSaga,
	addProjectSaga,
	fetchLeadDetailsSaga,
	updateLeadBasicDetailsSaga,
	fetchLeadProjectsSaga,
	fetchDepartmentsSaga,

	//
	fetchUserPermissionsSaga,
	updateUserPermissionsSaga,

	fetchProjectDetailsSaga,
	updateProjectDetailsSaga,
	changeAreaNicknameSaga,

	//ORGANIZATION
	fetchDesignationsSaga,
	updateEmployeeDetailsSaga,
	fetchManagerAutocompleteSaga,
	deleteEmployeeSaga,
	fetchUserByIdSaga,
	fetchAssignedProjectsSaga,
	fetchSelectedUserPermissionsSaga,

	//PROJECT ACTIVITIES
	fetchProjectActivitiesSaga,
	completeProjectActivitySaga,
	fetchAllApprovalSaga,
	updateActivityDetailsSaga,
	approveRequestSaga,
	fetchWarrantyClaimsSaga,
	fetchWarrantyClaimByIdSaga,
	updateWarrantyClaimSaga,
	approveWarrantyClaimSaga,
	rejectWarrantyClaimSaga,
	scheduleWarrantyClaimSaga,
	updateWarrantyClaimScheduleSaga,
	submitWarrantyQuoteSaga,
	submitWarrantyFinalQuoteSaga,
	updateWarrantyChargesSaga,
	updateWarrantyClaimStatusesSaga,
	updateWarrantyClaimDiscountSaga,
	fetchWarrantyDocumentsSaga,
	scheduleSiteVisitSaga,
	updateActivityDetailsSaga,
	uploadActivityDocumentSaga,
	fetchActivityDocumentsSaga,
	deleteActivityDocumentsSaga,

	// CUSTOMER
	getPredictionIdSaga,
	fetchCustomerDetailsSaga,
	getPredictionSaga,
	sendCustomerOTPSaga,
	verifyCustomerOTPSaga,
	resendCustomerOTPSaga,
	fetchFloorPlanImageSaga,
	updateFloorPlanSaga,
	uploadProjectDetailsSaga,
	getPreDesignQuotationSaga,
	getDefaultQuotationsSaga,
	fetchPreDesignSavedStateSaga,
	createQuotationSaga,
	fetchQuotationsSaga,
	fetchQuotationByIdSaga,
	fetchSavedQuotationSaga,
	addQuotationsSaga,
	updateQuotationSaga,
	fetchProductCategoriesSaga,
	fetchCutlistDataSaga,
	fetchOptimiserDataSaga,
	fetchOptimizedCutlistDataSaga,
	fetchPromoCodeHistorySaga,
	calculatePromoCodeAmountSaga,

	//COMMERCIALS
	fetchAllPaymentsSaga,
	ApprovePaymentSaga,
	fetchCustomerSlipSaga,
	fetchPaymentSlipSaga,
	fetchProjectAutocompleteSaga,
	createGstInvoiceSaga,
	fetchGstInvoiceSaga,

	//TICKETS
	fetchAllTicketsSaga,
	closeTicketSaga,

	fetchAssigneeDropdownSaga,
	fetchDesignerDropdownSaga,
	fetchProductionDropdownSaga,
	fetchTicketChatSaga,
	sendChatMessageSaga,
	closeTicketSaga,

	//HOLIDAYS
	fetchHolidaysSaga,
	addHolidaySaga,
	updateHolidaySaga,
	deleteHolidaySaga,

	//APPROVAL
	fetchAllApprovalSaga,
	fetchApprovalDocumentsSaga,
	approveRequestSaga,
	rejectRequestSaga,

	//Builder costing
	fetchCabinetMaterialsSaga,
	editCabinetMaterialsSaga,
	fetchFCCostingSaga,
	editFCCostingSaga,
	fetchFCMaterialCostingSaga,
	editFCMaterialCostingSaga,
	addFCMaterialCostingSaga,
	fetchFCLumenCostingSaga,
	editFCLumenCostingSaga,
	fetchWallPanelMaterialsSaga,
	editWallPanelMaterialsSaga,
	fetchCounterTopMaterialsSaga,
	editCounterTopMaterialsSaga,
	fetchWallTilesSaga,
	addWallTileSaga,
	updateWallTileSaga,
	fetchLightingMaterialsSaga,
	fetchDriverMaterialsSaga,
	fetchElectricalModulesSaga,
	editElectricalModulesSaga,
	fetchElectricalMaterialsSaga,
	editElectricalMaterialsSaga,
	fetchPaintMaterialsSaga,
	editPaintMaterialsSaga,
	fetchMouldingTypesSaga,
	fetchMouldingPatternsSaga,
	editMouldingTypesSaga,
	editMouldingPatternsSaga,
	fetchSFBMaterialsSaga,
	editSFBMaterialsSaga,
	fetchCurtainMaterialsSaga,
	editCurtainMaterialsSaga,
	fetchBuilderChargeConfigsSaga,
	upsertBuilderChargeConfigSaga,

	//Builder
	fetchCabinetStateSaga,
	updateCabinetStateSaga,
	fetchCabinetCutlistSaga,
	updateCabinetCutlistSaga,
	getCabinetCalculationSaga,
	updateCabinetMaterialsInBulkSaga,
	updateFCBuilderSaga,
	fetchAssigneeDropdownSaga,
	fetchDesignerDropdownSaga,
	getCounterTopCalculationSaga,
	fetchLedgerDataSaga,
	recalculateLedgerSaga,
	fetchProjectDiscountsSaga,
	addProjectDiscountSaga,
	editDiscountAmountSaga,
	editCashDiscountAmountSaga,
	applyPromoCodeSaga,
	removePromoCodeSaga,
	fetchProjectWarrantySaga,
	putLifetimeWarrantySaga,
	fetchOptimizedCutlistDataSaga,
	getCounterTopStateSaga,
	getLoftCalculationSaga,
	fetchLoftCutlistSaga,
	fetchLoftStateSaga,
	fetchWallPanelStateSaga,
	getWallPanelCalculationSaga,
	fetchWardrobeStateSaga,
	fetchWardrobeCalculationSaga,
	fetchWardrobeCutlistSaga,
	getElectricalCalculationSaga,
	getProjectElectricalStateSaga,
	updateElectricalStateSaga,
	getPaintBuilderCalculationSaga,
	getPaintBuilderStateSaga,
	fetchAllBuilderStatesSaga,
	getWallMouldingStateSaga,
	getWallMouldingCalculationSaga,
	fetchWallMouldingBuilderStateSaga,
	updatePreDesignBuilderSaga,
	fetchDrawerStateSaga,
	fetchDrawerCalculationSaga,
	fetchDrawerCutlistSaga,
	fetchLedgeStateSaga,
	fetchLedgeCalculationSaga,
	fetchLedgeCutlistSaga,
	fetchCurtainStateSaga,
	getCurtainCalculationSaga,

	// Dashboard
	fetchPromoCodeSaga,
	fetchProjectsCostsSaga,
	fetchProjectOverviewSaga,
	fetchStatusSummarySaga,
	fetchDashboardTicketsSaga,
	fetchDashboardProjectsSaga,
	fetchDashboardApprovalsSaga,
	fetchDashboardPromoCodeHistorySaga,
	createCustomPromoCodeSaga,
	fetchAnalyticsDataSaga,
	fetchFinancialDataSaga,
	fetchCRMDataSaga,
	fetchExecutiveDataSaga,
	fetchFCBuilderDataSaga,
	fetchFinanceDropdownSaga,
	fetchProcurementDropdownSaga,
	fetchManufacturingDropdownSaga,
	fetchProjectManagementDropdownSaga,

	//Incentives
	fetchTeamWiseShareSaga,
	fetchTeamWiseIncentivesSaga,
	fetchTeamWiseIncentivesByProjectIdSaga,

	fetchUserByIdSaga,
	fetchAssignedProjectsSaga,

	//Feedback
	createFeedbackSaga,
	fetchAllFeedbackSaga,
	getFeedbackByIdSaga,
	resolveFeedbackSaga,

	// Email Config
	fetchAllEmailCCConfigsSaga,
	getEmailCCConfigByNameSaga,
	upsertEmailCCConfigSaga,
	fetchEmailAutocompleteSaga,

	// AImagine / Imagen
	uploadInputImageSaga,
	generateImageSaga,
	generateRenderSaga
];
